export default __webpack_public_path__ + "static/media/p-k1.bd84dc39.png";